<script>
export default {
  data: () => ({
    whitelist: [
      'trackOrder',
    ],
    mountInterval: null,
  }),
  created() {
    let ua = navigator.userAgent.toLowerCase(),
      platform = navigator.platform.toLowerCase(),
      platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0],
      isMobile = /ios|android|webos/.test(platformName);

    if (!isMobile) {
      window.$zopim || (function(d, s) {
        var z = window.$zopim = function(c) { z._.push(c) },
          $ = z.s =
          d.createElement(s),
          e = d.getElementsByTagName(s)[0];
        z.set = function(o) {
          z.set.
          _.push(o)
        };
        z._ = [];
        z.set._ = [];
        $.async = !0;
        $.setAttribute("charset", "utf-8");
        $.src = "//v2.zopim.com/?2G49jHUlZLgQk1REVPOugqzWNNxQsU6a";
        z.t = +new Date;
        $.
        type = "text/javascript";
        e.parentNode.insertBefore($, e)
      })(document, "script");

      window.$zopim(function() {
        $zopim.livechat.departments.filter('Customer Service');
        $zopim.livechat.departments.setVisitorDepartment('Customer Service');
      });
    }
  },
  mounted() {
    this.mountInterval = setInterval(() => {
      if (document.querySelector('iframe[data-test-id="ChatWidgetButton-iframe"]')) {
        document.querySelector('iframe[data-test-id="ChatWidgetButton-iframe"]').setAttribute('title', 'live chat widget');

        if (!this.whitelist.includes(this.$route.name)) {
          document.querySelector('.zopim').classList.add('off-whitelist');
        }

        clearInterval(this.mountInterval);
      }
    }, 100);
  },
};
</script>

<template lang='pug'>
</template>

<style>
@import '~import/index';

.zopim.off-whitelist {
  display: none !important;
}
</style>